import { createOperation } from "../operations";

export const connectMembershipOperation = createOperation("MEMBERSHIP/CONNECT", { tracked: true, showSpinner: true });
export const switchMembershipOperation = createOperation("MEMBERSHIP/SWITCH", { showSpinner: true });
export const removeMembershipOperation = createOperation("MEMBERSHIP/REMOVE", { showSpinner: true });
export const findingBarcodeOperation = createOperation<string | null>("MEMBERSHIP/FINDING_BARCODE");
